export default __webpack_public_path__ + "static/media/c++.c0a0d2fd.png";